import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5559ea9c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5559ea9c')) {
      api.createRecord('5559ea9c', component.options)
    } else {
      api.reload('5559ea9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5559ea9c", function () {
      api.rerender('5559ea9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/typeCustomerManage/index.vue"
export default component.exports